// extracted by mini-css-extract-plugin
module.exports = {"dropMenuWrapper":"styles_dropMenuWrapper__PUw9V","icon":"styles_icon__fsDvE","menu":"styles_menu__M62yX"};